import { calendarInitState, calendarReducers } from "./reducer";
import { createSlice } from "@reduxjs/toolkit";

export const SLICE_NAME = "calendar";

export const calendarState = createSlice({
  name: SLICE_NAME,
  initialState: calendarInitState,
  reducers: calendarReducers,
});

export const ACTIONS = calendarState.actions;
export default calendarState.reducer;
